import React from 'react';
import { User, Phone, Mail, Award } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { createStudentViewPath } from '../../utils/studentRoutes';

const StudentIdCardWidget = ({ userData, mentorName, coordinatorName }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-xl shadow-lg overflow-hidden">
      {/* Header */}
      <div className="bg-blue-700 px-4 py-3 text-white">
        <h3 className="font-bold text-sm">YBIT - Student ID</h3>
        <p className="text-xs opacity-90">Semester I</p>
      </div>

      {/* Card Body */}
      <div className="bg-white p-4">
        {/* Photo & Name */}
        <div className="flex items-start space-x-4 mb-4">
          <div className="w-24 h-28 border-2 border-blue-600 rounded flex items-center justify-center bg-gray-50">
            <User className="w-12 h-12 text-gray-400" />
          </div>
          <div className="flex-1">
            <h4 className="font-bold text-gray-900 text-lg mb-1">
              {userData.firstName} {userData.fatherName} {userData.surname}
            </h4>
            <div className="space-y-1 text-sm">
              <div className="grid grid-cols-2 gap-x-3">
                <div>
                  <span className="text-gray-600 text-xs">Roll Number</span>
                  <p className="font-semibold text-gray-900">{userData.rollNumber}</p>
                </div>
                <div>
                  <span className="text-gray-600 text-xs">Date of Birth</span>
                  <p className="font-semibold text-gray-900">{userData.dob}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Details Grid */}
        <div className="grid grid-cols-2 gap-3 mb-4 text-sm">
          <div>
            <span className="text-gray-600 text-xs">Division</span>
            <p className="font-semibold text-gray-900">{userData.division}</p>
          </div>
          <div>
            <span className="text-gray-600 text-xs">Batch</span>
            <p className="font-semibold text-gray-900">{userData.batch}</p>
          </div>
        </div>

        {/* Contact */}
        <div className="mb-4 pb-4 border-b">
          <div className="flex items-center space-x-2 text-sm text-gray-700">
            <Phone className="w-4 h-4 text-gray-400" />
            <span>{userData.mobile}</span>
          </div>
        </div>

        {/* Staff Info */}
        <div className="space-y-2 mb-4 text-sm">
          <div>
            <span className="text-gray-600 text-xs">Mentor</span>
            <p className="font-medium text-gray-900">{mentorName || 'Not Assigned'}</p>
          </div>
          <div>
            <span className="text-gray-600 text-xs">Class Coordinator</span>
            <p className="font-medium text-gray-900">{coordinatorName || 'Not Assigned'}</p>
          </div>
        </div>

        {/* Action Button */}
        <button
          onClick={() => navigate(createStudentViewPath('/student/profile', userData.rollNumber))}
          className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
        >
          View Complete Profile
        </button>
      </div>
    </div>
  );
};

export default StudentIdCardWidget;
